import { Outlet } from "react-router-dom";
import { Providers } from "../providers";
import Navbar from "./navbar";
import { MaintenanceWrapper } from "./MaintenanceWrapper";
import { Footer } from "./footer";

const AppContent = () => {
  return (
    <>
      <Navbar />

      <Outlet />

      <Footer />
    </>
  );
};

export const App = () => {
  return (
    <Providers>
      <MaintenanceWrapper>
        <AppContent />
      </MaintenanceWrapper>
    </Providers>
  );
};
